import { Component, Input } from '@angular/core';

import { FormInputRadioComponent } from '@fcom/service-forms/components/common/form-input-radio.component';

@Component({
  selector: 'fin-radio-item',
  templateUrl: './radio-item.component.html',
  styleUrls: ['./radio-item.component.scss'],
})
export class RadioItemComponent extends FormInputRadioComponent {
  @Input()
  name?: string;
}
